import React from 'react';
import styled from 'styled-components';
import Modal from '../Modal';
import SecretaryManagementSection from './SecretaryManagementSection';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  entityType: 'lead' | 'client';
  entityId: number;
}

const Wrapper = styled.div`
  direction: rtl;
`;

const FooterRow = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
`;

const CloseButton = styled.button`
  padding: 0.5rem 1rem;
  background: #fff;
  color: var(--text-primary);
  border: 1px solid var(--border-color);
  border-radius: var(--border-radius-md);
  font-size: 0.9rem;
  cursor: pointer;

  &:hover {
    background: #f1f3f5;
  }
`;

const SecretaryManagementModal: React.FC<Props> = ({ isOpen, onClose, entityType, entityId }) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="ניהול הרשאות מזכירות"
      width="720px"
      maxWidth="95vw"
      footer={
        <FooterRow>
          <CloseButton onClick={onClose}>סגירה</CloseButton>
        </FooterRow>
      }
    >
      <Wrapper>
        <SecretaryManagementSection
          entityType={entityType}
          entityId={entityId}
          defaultOpen
          title="מזכירות עם גישה"
        />
      </Wrapper>
    </Modal>
  );
};

export default SecretaryManagementModal;
